import { Form, Button, Alert } from 'react-bootstrap';
import { Info } from 'lucide-react';

export function GroupInvites() {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100vh', backgroundColor: '#f8f9fa' }}>
      {/* Sidebar */}
      {/* <div
        style={{
          width: '250px',
          backgroundColor: '#fff',
          borderRight: '1px solid #dee2e6',
          padding: '1rem',
        }}
      >
        <h4 style={{ fontSize: '1rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>Account Settings</h4>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li style={{ marginBottom: '1rem', color: '#6c757d', cursor: 'pointer' }}>Login Information</li>
          <li style={{ marginBottom: '1rem', color: '#6c757d', cursor: 'pointer' }}>Notification Settings</li>
          <li style={{ marginBottom: '1rem', color: '#6c757d', cursor: 'pointer' }}>Privacy</li>
          <li style={{ marginBottom: '1rem', color: '#0d6efd', fontWeight: 'bold', cursor: 'pointer' }}>Group Invites</li>
          <li style={{ marginBottom: '1rem', color: '#6c757d', cursor: 'pointer' }}>Export Data</li>
          <li style={{ marginBottom: '1rem', color: '#6c757d', cursor: 'pointer' }}>Delete Account</li>
        </ul>
      </div> */}

      {/* Main Content */}
      <div style={{ flexGrow: 1, padding: '2rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold' }}>Group Invites</h2>
          {/* <Button
            variant="outline-secondary"
            style={{
              borderColor: '#dee2e6',
              color: '#6c757d',
              backgroundColor: '#fff',
              fontWeight: 'bold',
            }}
          >
            View Profile
          </Button> */}
        </div>

        <Alert
          variant="primary"
          style={{
            display: 'flex',
            marginBottom: '1.5rem',
            backgroundColor: '#e7f1ff',
            border: 'none',
          }}
        >
          <div
            style={{
              backgroundColor: '#0d6efd',
              padding: '0.5rem',
              borderRadius: '0.375rem',
              marginRight: '0.75rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Info style={{ color: '#fff' }} size={24} />
          </div>
          <div style={{ flexGrow: 1, color: '#212529' }}>
            Currently every member of the community can invite you to join their groups. Optionally, you may restrict group invites to your connections only.
          </div>
        </Alert>

        <Form>
          <Form.Check
            type="checkbox"
            id="restrict-invites"
            label="Restrict Group invites to members who are connected."
            style={{
              marginBottom: '1.5rem',
              color: '#212529',
            }}
          />

          <Button
            variant="primary"
            size="lg"
            style={{
              padding: '0.75rem 2rem',
              backgroundColor: '#0d6efd',
              borderColor: '#0d6efd',
              fontSize: '1rem',
              fontWeight: 'bold',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#0b5ed7';
              e.target.style.borderColor = '#0a58ca';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#0d6efd';
              e.target.style.borderColor = '#0d6efd';
            }}
          >
            Save
          </Button>
        </Form>
      </div>
    </div>
  );
}
